var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7f56d9",
    d: "M254.81 332.554c-6.858 0-12.413-5.577-12.413-12.428V24.428c0-6.851 5.555-12.428 12.413-12.428s12.413 5.577 12.413 12.428v295.698c0 6.851-5.555 12.428-12.413 12.428z",
    opacity: 1,
    "data-original": "#c43961",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f56d9",
    d: "M76.482 334.585c-4.009 0-7.949-1.94-10.337-5.547-3.804-5.699-2.266-13.398 3.44-17.217 32.859-21.886 29.608-109.64 25.576-141.62-.091-60.564 47.916-108.579 106.927-108.579H307.53c59.011 0 107.01 48.015 107.01 107.033.015 45.378 7.457 124.796 27.38 144.712 4.85 4.85 4.85 12.731.008 17.581-4.85 4.85-12.708 4.85-17.558 0-33.685-33.677-34.655-149.228-34.655-162.293 0-45.317-36.867-82.177-82.185-82.177H202.089c-45.317 0-82.192 36.86-82.192 82.177 1.591 11.761 14.899 129.555-36.534 163.839-2.122 1.394-4.509 2.091-6.881 2.091z",
    opacity: 1,
    "data-original": "#c43961",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f56d9",
    d: "M167.275 500c-4.016 0-7.957-1.94-10.352-5.547-3.797-5.699-2.251-13.398 3.456-17.217 8.889-5.911 13.444-49.409 9.738-93.059-.045-33.526 26.357-59.928 58.806-59.928h51.766c32.449 0 58.852 26.402 58.852 58.867.008 44.165 5.434 88.876 11.617 95.696 4.524 5.002 4.441 12.883-.44 17.551-4.873 4.668-12.383 4.789-17.142 0-17.028-17.036-18.862-84.875-18.862-113.247 0-18.763-15.262-34.011-34.026-34.011h-51.766c-18.763 0-34.026 15.247-34.026 34.011 1.895 21.582 6.108 96.879-20.756 114.793-2.113 1.394-4.5 2.091-6.865 2.091zM488.8 268.413c-59.428 0-88.831-41.407-96.075-63.292-2.16-6.517 1.372-13.55 7.881-15.702 6.517-2.092 13.504 1.394 15.679 7.851.765 2.213 16.778 46.287 72.515 46.287 6.858 0 12.413 5.577 12.413 12.428-.001 6.85-5.555 12.428-12.413 12.428zM23.2 268.413c-6.858 0-12.413-5.577-12.413-12.428s5.555-12.428 12.413-12.428c55.964 0 71.871-44.408 72.515-46.317 2.22-6.457 9.245-10.003 15.725-7.76 6.472 2.183 9.98 9.154 7.836 15.641-7.245 21.885-36.64 63.292-96.076 63.292z",
    opacity: 1,
    "data-original": "#c43961",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f56d9",
    d: "M150.028 299.423h-.121c-6.843-.061-12.345-5.668-12.292-12.519 0-.455-.023-45.893-29.911-62.171-6.025-3.304-8.245-10.822-4.956-16.854 3.281-6.002 10.822-8.275 16.839-4.971 43.097 23.522 42.885 81.783 42.854 84.269-.084 6.789-5.623 12.246-12.413 12.246zM361.965 299.423c-6.79 0-12.33-5.456-12.413-12.246-.03-2.486-.243-60.746 42.854-84.269 6.009-3.304 13.557-1.031 16.839 4.971 3.289 6.032 1.069 13.55-4.956 16.854-29.888 16.278-29.911 61.716-29.911 62.171.053 6.851-5.449 12.458-12.292 12.519h-.121zM370.929 458.32c-34.223 0-51.046-26.887-55.154-41.104-1.902-6.608 1.895-13.489 8.48-15.368 6.532-1.94 13.421 1.849 15.353 8.397.781 2.516 7.904 23.219 31.32 23.219 6.858 0 12.413 5.577 12.413 12.428.001 6.851-5.554 12.428-12.412 12.428zM138.887 458.32c-6.858 0-12.413-5.578-12.413-12.428 0-6.851 5.555-12.428 12.413-12.428 23.507 0 30.593-20.855 31.328-23.25 1.993-6.487 8.897-10.155 15.429-8.306 6.532 1.94 10.291 8.76 8.397 15.308-4.108 14.217-20.932 41.104-55.154 41.104z",
    opacity: 1,
    "data-original": "#c43961",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCns);
export default __webpack_public_path__ + "static/media/cns.fa5c7e724d4fcac943de842ccc3e730a.svg";
export { ForwardRef as ReactComponent };